import { api } from "@/api";
import moment from "moment";
const inventoryStore = {
  state: {
    inventorySync: null,
    inventoryTemplate: undefined,
    inventoryRecords: [],
    inventoryTransactions: [],
    lastIntegratedTransactionReport: undefined,
    inventoryRecordsCorrections: [],
    integratedTransactions: [],
    lastIntegratedTransactionSync: null,
    firstInventoryEdit: true,
    dayChoices: [
      { value: 0, text: "Lundi", jsValue: 1, dbText: "monday" },
      { value: 1, text: "Mardi", jsValue: 2, dbText: "tuesday" },
      { value: 2, text: "Mercredi", jsValue: 3, dbText: "wednesday" },
      { value: 3, text: "Jeudi", jsValue: 4, dbText: "thursday" },
      { value: 4, text: "Vendredi", jsValue: 5, dbText: "friday" },
      { value: 5, text: "Samedi", jsValue: 6, dbText: "saturday" },
      { value: 6, text: "Dimanche", jsValue: 0, dbText: "sunday" }
    ],
    expirations: [],
    wastes: []
  },
  getters: {
    getInventoryRecords(state) {
      return state.inventoryRecords;
    },
    getInventoryTransactions(state) {
      return state.inventoryTransactions;
    },
    getInventoryTemplate(state) {
      return state.inventoryTemplate;
    },
    getInventorySync(state) {
      return moment(state.inventorySync).format("lll");
    },
    getFirstInventoryEdit(state) {
      return state.firstInventoryEdit;
    },
    getInventoryRecordsCorrections(state) {
      return state.inventoryRecordsCorrections;
    },
    getIntegratedTransactions(state) {
      return state.integratedTransactions;
    },
    getUncompletedIntegratedTransactions(state) {
      return state.integratedTransactions.filter(x => x.is_completed === false);
    },
    getDayChoices(state) {
      return state.dayChoices;
    },
    getLastIntegratedTransactionReport(state) {
      return state.lastIntegratedTransactionReport;
    },
    getExpirations(state) {
      return state.expirations;
    },
    getWastes(state) {
      return state.wastes;
    }
  },
  mutations: {
    setInventoryRecords(state, value) {
      state.inventoryRecords = value;
      state.inventorySync = new Date();
    },
    setInventoryTransactions(state, value) {
      state.inventoryTransactions = value;
      state.inventorySync = new Date();
    },
    setInventoryTemplates(state, value) {
      state.inventoryTemplate = value;
    },
    setFirstInventoryEdit(state, value) {
      state.firstInventoryEdit = value;
    },
    updateInventoryRecord(state, value) {
      state.inventoryRecords = state.inventoryRecords.filter(
        x => x.fk_product !== value.fk_product
      );
      state.inventoryRecords.push(value);
    },
    setInventoryRecordsCorrections(state, value) {
      state.inventoryRecordsCorrections = value;
    },
    setIntegratedTransactions(state, value) {
      state.integratedTransactions = value;
      state.lastIntegratedTransactionSync = new Date();
    },
    setLastIntegratedTransactionReport(state, value) {
      state.lastIntegratedTransactionReport = value;
    },
    setExpirations(state, value) {
      state.expirations = value;
    },
    setWastes(state, value) {
      state.wastes = value;
    }
  },
  actions: {
    async loadInventoryRecords(context, payload) {
      if (
        context.state.inventoryRecords.length > 0 &&
        moment().diff(moment(context.state.inventorySync), "minutes") < 5 &&
        moment().diff(
          moment(context.state.lastIntegratedTransactionSync),
          "minutes"
        ) > 1
      ) {
        setTimeout(async () => {
          const expirationRes = await api.getExpirations();
          context.commit("setExpirations", expirationRes);
          const res = await api.getInventoryRecords(payload);
          context.commit("setInventoryRecords", res);
        }, 5);
        return Promise.resolve();
      } else {
        const expirationRes = await api.getExpirations();
        context.commit("setExpirations", expirationRes);
        const res = await api.getInventoryRecords(payload);
        context.commit("setInventoryRecords", res);
      }
    },
    async loadExpirations(context) {
      const expirationRes = await api.getExpirations();
      context.commit("setExpirations", expirationRes);
    },
    async loadWastes(context) {
      const res = await api.getInventoryTransactions({
        waste: true,
        start: moment().subtract(7, "d")
      });
      context.commit("setWastes", res);
    },
    async loadInventoryTransaction(context, payload) {
      const res = await api.getInventoryTransactions(payload);
      context.commit("setInventoryTransactions", res);
    },
    async loadInventoryTemplates(context, payload) {
      const res = await api.getInventoryTemplates(payload);
      if (res && res !== "") {
        context.commit("setInventoryTemplates", res);
        return res;
      } else {
        return undefined;
      }
    },
    async addInventoryTemplate(context, payload) {
      const res = await api.postInventoryTemplate(payload);
      context.commit("addInventoryTemplate", res);
    },
    async makeFirstInventoryEdit(context) {
      context.commit("setFirstInventoryEdit", false);
    },
    async updateInventoryRecord(context, payload) {
      context.commit("updateInventoryRecord", payload);
    },
    async loadInventoryRecordsCorrections(context, payload) {
      const res = await api.getInventoryRecordsCorrections(payload);
      context.commit("setInventoryRecordsCorrections", res);
    },
    async loadIntegratedTransactions(context, payload) {
      const res = await api.getIntegratedTransactions(payload);
      context.commit("setIntegratedTransactions", res);
    },
    async loadLastIntegratedTransactionReport(context) {
      const res = await api.getLastIntegratedInventoryTransactionReport();
      context.commit("setLastIntegratedTransactionReport", res);
    }
  }
};
export default inventoryStore;
